import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "api/axiosInstance";

export const loginUser = createAsyncThunk(
    "auth/login",
    async (credentials, thunkAPI) => {
        try {
            const { data } = await api.post("/auth/login", credentials, { showNotify: false });
            localStorage.setItem("user", JSON.stringify(data.user));
            localStorage.setItem("token", data.token);
            return thunkAPI.fulfillWithValue(data);
        } catch (err) {
            const message = err.response?.data?.error || err.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const refreshToken = createAsyncThunk(
    "auth/refresh",
    async (_, thunkAPI) => {
        const refreshToken = thunkAPI.getState().auth.refreshToken;

        const { data } = await api.post("/auth/refresh", {
            refreshToken
        });

        return data;
    }
);

const authSlice = createSlice({
    name: "auth",
    initialState: {
        user: null,
        role: null,
        token: null,
        refreshToken: null,
        loading: false,
        error: null,
        permissions: [],
        tenant: null,
        modules: []
    },
    reducers: {
        logoutUser: (state) => {
            state.user = null;
            state.role = null;
            state.token = null;
            state.refreshToken = null;
            localStorage.removeItem("token");
            localStorage.removeItem("user");
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginUser.pending, (state) => {
                state.loading = true;
            })
            .addCase(loginUser.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload.user;
                state.role = action.payload.user.role;
                state.token = action.payload.token;
                state.refreshToken = action.payload.refreshToken;
                state.tenant = action.payload.tenant?.toLowerCase();
                state.permissions = action.payload.permissions;
                state.modules = action.payload.modules;
            })
            .addCase(loginUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })
            .addCase(refreshToken.fulfilled, (state, action) => {
                state.token = action.payload.accessToken;
            });
    }
});

export const { logoutUser } = authSlice.actions;
export default authSlice.reducer;
